import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
import * as moment from 'moment';
declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent implements OnInit {
  faqList: any = "";
  videorequest: any = {
    pagesize: -1,
    page: 1
    };
  constructor(
    private allpagesService: AllPageService
  ) { }

  ngOnInit() {
    let request = Object.assign({}, this.videorequest);
    this.allpagesService.getFaq(request).then((data: any) => {
			this.faqList = data.data;
			console.log(this.faqList);
      setTimeout(() => {
        jQuery(".set > a").on("click", function() {
          if (jQuery(this).hasClass("active")) {
            jQuery(this).removeClass("active");
            jQuery(this)
              .siblings(".content")
              .slideUp(200);
            jQuery(".set > a i")
              .removeClass("fa-caret-up")
              .addClass("fa-caret-down");
          } else {
            jQuery(".set > a i")
              .removeClass("fa-caret-up")
              .addClass("fa-caret-down");
            jQuery(this)
              .find("i")
              .removeClass("fa-caret-down")
              .addClass("fa-caret-up");
            jQuery(".set > a").removeClass("active");
            jQuery(this).addClass("active");
            jQuery(".content").slideUp(200);
            jQuery(this)
              .siblings(".content")
              .slideDown(200);
          }
        });
      }, 1000);
		});
    
  
  }

}
